import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.less';
import RootProvider from './RootProvider';
import './services/localization/config';
import { QueryClient, QueryClientProvider } from 'react-query';
import { persistQueryClient } from 'react-query/persistQueryClient-experimental';
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental';
import { initMfes } from '@cw-elements/mfe-setup/init';
if (import.meta.env.VITE_APP_IS_AXIOS_MOCK) {
  import('./__mocks__');
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
      cacheTime: 1000 * 60 * 60 * 1, // 1 hour,
    },
    mutations: {
      retry: false,
    },
  },
});

(async () => {
  const localStoragePersistor = createWebStoragePersistor({ storage: window.localStorage });
  persistQueryClient({
    queryClient,
    persistor: localStoragePersistor,
  });

  await initMfes({
    'prescription-exporter': `${import.meta.env.VITE_APP_CW_MFE_URL}/prescription-exporter`,
    'machinery-field-operations': `${
      import.meta.env.VITE_APP_CW_MFE_URL
    }/machinery-field-operations`,
    'connect-files': `${import.meta.env.VITE_APP_CW_MFE_URL}/connect-files`,
    'topbar-navigation': `${import.meta.env.VITE_APP_CW_MFE_URL}/topbar-navigation`,
  });

  const root = createRoot(document.getElementById('root'));
  root.render(
    <RootProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </RootProvider>,
  );
})();
